import React from 'react';

import {
    BackgroundColor,
    ImageColumn as ImageColumnType,
    SplitColumnType
} from '../../../models/strapi/split_column';

import { colors } from '../../../shared/colors';

import * as styles from './column.module.scss';

interface Props {
    data: ImageColumnType;
    isImageLeft: boolean;
    variant: SplitColumnType['variant'];
    textBackgroundColor: BackgroundColor['backgroundColor'];
    onClickFunctions?: {
        [key: string]: () => void;
    };
}

const ImageColumn = ({ data, isImageLeft, variant, textBackgroundColor }: Props) => {
    const paddingStyles = data.padding
        ? isImageLeft
            ? 'leftImagePadding'
            : 'rightImagePadding'
        : '';

    const variantClass =
        variant === 'fourty_sixty'
            ? 'fourtySixty'
            : variant === 'sixty_fourty'
            ? 'sixtyFourty'
            : '';

    const classes = `${styles[variantClass]} ${styles[paddingStyles]}`;

    return (
        <div
            className={`${classes} ${styles.imageContainer}`}
            style={{
                backgroundColor: colors[textBackgroundColor],
                background: `url(${
                    data && data.image && data.image.url
                }) center center / cover no-repeat`
            }}></div>
    );
};

export default ImageColumn;
